<template lang="pug">
  div
    div.container-fluid(style="margin-top:25px;", v-show="!$store.state.auth.loggedin")
      div.row.justify-content-center
        div.col-12.col-lg-11.col-xl-10
          div.row.justify-content-center
            div.col-12.col-sm-5.col-xl-4(style="margin-bottom:15px;")
              div.row.justify-content-center.h-100
                div.col-11.form-colored
                  form(style="text-align: center;")
                    span ログインして購入手続きへ
                    hr.hr15
                    input(v-model="auth.email", :class="is_authnotmatch? 'form-control is-invalid':'form-control'", type="text", style="width:90%; margin: auto;", placeholder="Email", required="required", autofocus="")
                    hr.hr15
                    input(v-model="auth.password", :class="is_authnotmatch? 'form-control is-invalid':'form-control'", type="password", style="width:90%; margin: auto;", placeholder="Password", required="required", v-show-password-input)
                    hr.hr20
                    button.form-control.btn.btn-primary(type="button", style="width:90%;", @click="login", :disabled="!checkLogin") {{ loginbtnlabel }}
                    p.text-danger(v-show="is_authnotmatch", style="margin-top: 10px; margin-bottom: 0px;") Email/Passwordが一致しません
                    p.text-danger(v-show="is_authfail", style="margin-top: 10px; margin-bottom: 0px;") ログインに失敗しました
                    hr.hr20
                    a(href="/forgot_password") パスワードを忘れましたか？
            div.col-12.col-sm-5.col-xl-4(style="margin-bottom:15px;")
              div.row.justify-content-center.h-100
                div.col-11.form-colored
                  form(style="text-align: center;")
                    span 登録して購入手続きへ
                    hr.hr15
                    div.input-group(style="width:90%; margin: auto;")
                      input.form-control(v-model="signup.family", type="text", placeholder="姓", required="required")
                      input.form-control(v-model="signup.first", type="text", placeholder="名", required="required")
                    hr.hr15
                    input(v-model="signup.email", :class="is_signupconflict? 'form-control is-invalid':'form-control'", type="text", style="width:90%; margin: auto;", placeholder="Email", required="required")
                    hr.hr15
                    input.form-control(v-model="signup.password", type="password", style="width:90%; margin: auto;", placeholder="Password（半角英数字記号6文字以上）", required="required", v-show-password-input)
                    hr.hr20
                    button.form-control.btn.btn-primary(type="button", style="width:90%;", @click="SignupUser" :disabled="!checkSignup") {{ signupbtnlabel }}
                    p.text-danger(v-show="is_signupconflict", style="margin-top: 10px; margin-bottom: 10px;") このメールアドレスは既に登録されています
                    p.text-danger(v-show="is_signupfail", style="margin-top: 10px; margin-bottom: 10px;") 登録に失敗しました

      div.row.justify-content-center.form-colored-row(v-show="!$store.state.auth.loggedin")
        div.col-12.col-sm-10.col-md-9.form-colored.first
          form
            label.form-label ログインして購入手続きへ
            div.form-row.justify-content-center
              div.col-12.col-sm-10.col-md-8.col-lg-4(style="margin-top:10px;")
                input(v-model="auth.email", :class="is_authnotmatch? 'form-control is-invalid':'form-control'", type="text", placeholder="メール", required="required", autofocus="", style="margin-bottom: 5px;")
                span.text-danger(v-show="is_authnotmatch") メールアドレス/パスワードが一致しません
                span.text-danger(v-show="is_authfail") ログインに失敗しました
              div.col-12.col-sm-10.col-md-8.col-lg-4(style="margin-top:10px;")
                input(v-model="auth.password", :class="is_authnotmatch? 'form-control is-invalid':'form-control'", type="password", placeholder="パスワード", required="required", style="margin-bottom: 5px;")
              div.col-12.col-sm-10.col-md-8.col-lg-4(style="text-align: right; margin-top:10px;")
                button.btn.btn-primary.btn-block(type="button", @click="login", :disabled="!checkLogin", style="margin-bottom: 15px;") {{ loginbtnlabel }}
                a(href="/forgot_password") パスワードを忘れましたか？
      div.row.justify-content-center.form-colored-row(v-show="!$store.state.auth.loggedin")
        div.col-12.col-sm-10.col-md-9.form-colored
          form
            label.form-label 登録して購入手続きへ
            div.form-row(:class="this.width()<992? 'justify-content-center':''")
              div.col-12.col-sm-10.col-md-8.col-lg-8(style="margin-top: 5px;")
                div.input-group(style="margin-bottom: 1rem;")
                  input.form-control(v-model="signup.family", type="text", placeholder="姓", required="required")
                  input.form-control(v-model="signup.first", type="text", placeholder="名", required="required")

              //- div.col-12.col-sm-10.col-md-8.col-lg-4(style="margin-top: 5px;")
              //-   div.form-group
              //-     input.form-control(v-model="signup.family", type="text", placeholder="姓", required="required")
              //- div.col-12.col-sm-10.col-md-8.col-lg-4(style="margin-top: 5px;")
              //-   div.form-group
              //-     input.form-control(v-model="signup.first", type="text", placeholder="名", required="required")
            div.form-row(:class="this.width()<992? 'justify-content-center':''")
              div.col-12.col-sm-10.col-md-8.col-lg-4(style="margin-top: 5px;")
                div.form-group
                  input(v-model="signup.email",:class="is_signupconflict? 'form-control is-invalid':'form-control'" , type="text", placeholder="メール", required="required")
                  span.text-danger(v-show="is_signupconflict") このメールアドレスは既に登録されています
                  span.text-danger(v-show="is_signupfail") 登録に失敗しました
              div.col-12.col-sm-10.col-md-8.col-lg-4(style="margin-top: 5px;")
                div.form-group
                  input.form-control(v-model="signup.password", type="password", placeholder="パスワード（6文字以上）", required="required", v-show-password-input)
              div.col-12.col-sm-10.col-md-8.col-lg-4(style="margin-top: 5px;")
                button.btn.btn-primary.btn-block(type="button", @click="SignupUser", :disabled="!checkSignup") {{ signupbtnlabel }}

    div.modal#cartchangeModal(tabindex="-1", role="dialog", aria-labelledby="cartchangeModalLabel", aria-hidden="true")
      div.modal-dialog.modal-dialog-centered(role="document")
        div.modal-content
          div.modal-header
            h5.modal-title#cartchangeModalLabel カートのアップデート通知
            button.close(type="button", data-dismiss="modal", aria-label="Close")
              span(aria-hidden="true") &times;
          div.modal-body.text-left
            | 前回ログイン時のカートが復元され、現在のカートと統合されました。
            br
            | 購入確定前に、カート内を再度ご確認下さい。
          div.modal-footer
            button.btn.btn-primary(type="button", data-dismiss="modal") OK

    div.modal#signupModal(tabindex="-1", role="dialog", aria-labelledby="signupModalLabel", aria-hidden="true")
      div.modal-dialog.modal-dialog-centered(role="document")
        div.modal-content
          div.modal-header
            h5.modal-title#signupModalLabel 登録完了
            button.close(type="button", data-dismiss="modal", aria-label="Close")
              span(aria-hidden="true") &times;
          div.modal-body.text-left 
            | ありがとうございます。
            br
            | Gokaku Essay Libraryへのアカウント登録が完了しました。
          div.modal-footer
            button.btn.btn-primary(type="button", data-dismiss="modal", @click="AfterSignup") 続ける


</template>

<script>
import LoginMixin from '@/mixins/LoginMixin.js'

export default {
  name: 'LoginVue',
  components: {
  },
  mixins:[ LoginMixin ],
  methods:{
    width (){
      return window.innerWidth;
    }
  }
}
</script>

<style scoped>


.form-colored-row {
  margin-top:25px;
}

.form-colored {
  text-align: left;
  background-color: rgb(247, 250, 252);
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
  padding: 20px;
}
.form-colored.first {
  padding-bottom: 15px;
}

.form-label {
  margin-bottom:7px;
}

.hr15 {
  height: 15px;
  border: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
}

.hr20 {
  height: 20px;
  border: none;
  margin: 0px;
  padding: 0px;
  width: 100%;
}

</style>
